<template>
    <router-link :to="link">
        <div class="box">
            <article class="media">
                <div class="media-left">
                    <div class="circle" :class="circleColor">
                        <span class="number" :class="circleColor">{{ id }}</span>
                    </div>
                </div>
                <div class="media-content">
                    <div class="content">
                        <p>
                            <strong>{{ beneficiaryName }}</strong> <small>{{ nric }}</small>
                            <br>
                            {{ unit }}, {{ block }} {{ street }}
                        </p>
                    </div>
                </div>
                <div class="media-right">
                    <div v-if="!isBeneficiaryActive">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 128 128">
                            <circle cx="64.25" cy="64.28" r="54.44" fill="#fff" />
                            <path fill="#db4437"
                                d="M63.99 128.01c-35.29 0-64-28.71-64-64s28.71-64 64-64s64 28.71 64 64s-28.71 64-64 64zm0-117.11c-29.29 0-53.11 23.83-53.11 53.11c0 29.29 23.83 53.11 53.11 53.11S117.1 93.3 117.1 64.01c0-29.28-23.83-53.11-53.11-53.11z" />
                            <path fill="#db4437" d="m111.37 103.73l-8.43 8.41l-86.31-85.73L25.06 18z" />
                        </svg>
                    </div>
                    <div v-else-if="drivingDelivery">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="m5 11l1.5-4.5h11L19 11m-1.5 5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-11 0A1.5 1.5 0 0 1 5 14.5A1.5 1.5 0 0 1 6.5 13A1.5 1.5 0 0 1 8 14.5A1.5 1.5 0 0 1 6.5 16M18.92 6c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.22.42-1.42 1L3 12v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8l-2.08-6Z" />
                        </svg>
                    </div>
                    <div v-else-if="selfCollection">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="M16.78 21.84a1.998 1.998 0 1 1-1.56-3.68a1.998 1.998 0 1 1 1.56 3.68M7.62 6c1.11 0 2-.89 2-2a2 2 0 0 0-2-2c-1.12 0-2 .9-2 2c0 1.11.88 2 2 2m14.43 10.34L18.2 18c.22.22.42.5.56.82c.14.33.2.68.24 1l3.83-1.64l-.78-1.84M10.16 8.78l.74 1.81c-.24-.09-.46-.21-.64-.33c-.6-.39-1.04-.88-1.33-1.46l-.74-1.57c-.19-.35-.42-.61-.74-.79c-.29-.17-.6-.26-.92-.26c-.32 0-.62.08-.91.22c-1.4 1.1-1.75 3.14-1.75 3.14l-.34 1.57c-.09.52-.14 1.04-.14 1.57v4.96L1 20.87L2.5 22l2.77-3.75l.17-3.25l1.68 2.34V22h1.85v-6.06l-1.85-2.61v-.65c0-.44 0-.87.11-1.29l.35-1.2c.38.55.84 1.03 1.39 1.44c.45.34 1.71.94 2.9 1.23L14 17.8c.22-.22.5-.42.83-.56c.32-.14.67-.2.99-.24L12 8l-1.84.78m5.2 3.34l1.96 4.6l5.63-2.41L21 9.72" />
                        </svg>
                    </div>
                    <div v-else>
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3L2 12h3v8h5Z" />
                        </svg>
                    </div>
                </div>
            </article>
        </div>
    </router-link>
</template>

<script>
export default {
    props: [
        'id',
        'isBeneficiaryActive',
        'beneficiaryName',
        'nric',
        'selfCollection',
        'drivingDelivery',
        'unit',
        'block',
        'street'
    ],
    computed: {
        link() {
            return "/beneficiary/" + this.id;
        },
        circleColor() {
            return this.isBeneficiaryActive ? 'active' : 'inactive';
        }
    }
}

</script>

<style scoped>
.box {
    margin-bottom: 0.8rem;
}

.media-right {
    margin-left: 10px;
}

.circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.active {
    background-color: aquamarine;
}

.inactive {
    background-color: gainsboro;
}

.number {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 0%;
}
</style>